<div class="card sale-chart" style="width:320px;">
  <div class="card-body">
    <div class="d-flex">
      <div class="flex-shrink-0">
        <div class="sale-detail">
          <div class="icon"><app-feather-icon [icon]="data?.icon"></app-feather-icon></div>
          <div class="sale-content">
            <h3>{{ data?.tittle }}</h3>
            <p>{{ data?.sale }}</p>
          </div>
        </div>
      </div>
      <div class="small-chart-view sales-chart" id="sales-chart">
        <ng-container *ngIf="isLoading">
          <app-loader text="Зареждане Моля изчакайте..."></app-loader>
        </ng-container>
        <ng-container *ngIf="!isLoading">
          <apx-chart [series]="data.series"
                     [chart]="data.chart"
                     [plotOptions]="data.plotOptions"
                     [stroke]="data.stroke"
                     [states]="data.states"
                     [annotations]="data.annotations"
                     [colors]="data.colors"
                     [yaxis]="data.yaxis"
                     [xaxis]="data.xaxis"
                     [legend]="data.legend"
                     [tooltip]="data.tooltip"
                     [dataLabels]="data.dataLabels"
                     [grid]="data.grid"
                     [responsive]="data.responsive">
          </apx-chart>
        </ng-container>
      </div>
    </div>
  </div>
</div>
